import http from "./httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/ponolts/";
const url = apiUrl + endPoint;

export async function getPonOLTs() {
  return await http.get(url);
}

export async function getPonOLTsByRouter() {
  return await http.get(url + "router");
}

export async function getPonOLTById(oltId) {
  return await http.get(url + oltId);
}

export async function deletePonOLT(oltId) {
  return await http.delete(url + oltId);
}

export async function addPonOLT(olt) {
  return await http.post(url, olt);
}

export async function updatePonOLT(olt) {
  const payload = { ...olt };
  const oltId = payload._id;
  delete payload._id;
  return await http.put(url + oltId, payload);
}

export async function pingPonOLT(oltId) {
  return await http.put(url + "ping/" + oltId);
}
